/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestGetAmazonItemsListRequest
 */
export interface RequestGetAmazonItemsListRequest {
    /**
     * NULL 許容 (商品名未指定)
     * @type {string}
     * @memberof RequestGetAmazonItemsListRequest
     */
    amazonItemName?: string;
    /**
     * NULL 許容 (ASIN未指定)
     * @type {string}
     * @memberof RequestGetAmazonItemsListRequest
     */
    asin?: string;
    /**
     * NULL 許容 (ユーザー指定なしのケース)
     * @type {number}
     * @memberof RequestGetAmazonItemsListRequest
     */
    createdUserId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetAmazonItemsListRequest
     */
    direction?: number;
    /**
     * NULL 許容 (FNSKU未指定)
     * @type {string}
     * @memberof RequestGetAmazonItemsListRequest
     */
    fnskuCode?: string;
    /**
     * NULL 許容 (JANコード未指定)
     * @type {string}
     * @memberof RequestGetAmazonItemsListRequest
     */
    janCode?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestGetAmazonItemsListRequest
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetAmazonItemsListRequest
     */
    pageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestGetAmazonItemsListRequest
     */
    planName?: string;
    /**
     * NULL 許容 (SKU未指定)
     * @type {string}
     * @memberof RequestGetAmazonItemsListRequest
     */
    sku?: string;
    /**
     * ExpiryDate     *time.Time `json:"expiry_date,omitempty"`           // NULL 許容 (賞味期限未指定)
     * @type {number}
     * @memberof RequestGetAmazonItemsListRequest
     */
    sortKey?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetAmazonItemsListRequest
     */
    statusId?: number;
    /**
     * 必須
     * @type {number}
     * @memberof RequestGetAmazonItemsListRequest
     */
    tenantId: number;
    /**
     * BaseID         uint    `json:"base_id" validate:"required"`
     * @type {number}
     * @memberof RequestGetAmazonItemsListRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the RequestGetAmazonItemsListRequest interface.
 */
export function instanceOfRequestGetAmazonItemsListRequest(value: object): value is RequestGetAmazonItemsListRequest {
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestGetAmazonItemsListRequestFromJSON(json: any): RequestGetAmazonItemsListRequest {
    return RequestGetAmazonItemsListRequestFromJSONTyped(json, false);
}

export function RequestGetAmazonItemsListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestGetAmazonItemsListRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'amazonItemName': json['amazon_item_name'] == null ? undefined : json['amazon_item_name'],
        'asin': json['asin'] == null ? undefined : json['asin'],
        'createdUserId': json['created_user_id'] == null ? undefined : json['created_user_id'],
        'direction': json['direction'] == null ? undefined : json['direction'],
        'fnskuCode': json['fnsku_code'] == null ? undefined : json['fnsku_code'],
        'janCode': json['jan_code'] == null ? undefined : json['jan_code'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['page_size'] == null ? undefined : json['page_size'],
        'planName': json['plan_name'] == null ? undefined : json['plan_name'],
        'sku': json['sku'] == null ? undefined : json['sku'],
        'sortKey': json['sort_key'] == null ? undefined : json['sort_key'],
        'statusId': json['status_id'] == null ? undefined : json['status_id'],
        'tenantId': json['tenant_id'],
        'userId': json['user_id'],
    };
}

export function RequestGetAmazonItemsListRequestToJSON(json: any): RequestGetAmazonItemsListRequest {
    return RequestGetAmazonItemsListRequestToJSONTyped(json, false);
}

export function RequestGetAmazonItemsListRequestToJSONTyped(value?: RequestGetAmazonItemsListRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amazon_item_name': value['amazonItemName'],
        'asin': value['asin'],
        'created_user_id': value['createdUserId'],
        'direction': value['direction'],
        'fnsku_code': value['fnskuCode'],
        'jan_code': value['janCode'],
        'page': value['page'],
        'page_size': value['pageSize'],
        'plan_name': value['planName'],
        'sku': value['sku'],
        'sort_key': value['sortKey'],
        'status_id': value['statusId'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
    };
}

